/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventFromJSON, EventToJSON, } from './Event';
import { ResponseChangeUserFromJSON, ResponseChangeUserToJSON, } from './ResponseChangeUser';
/**
 * Check if a given object implements the ResponseChange interface.
 */
export function instanceOfResponseChange(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fromValue' in value) || value['fromValue'] === undefined)
        return false;
    if (!('toValue' in value) || value['toValue'] === undefined)
        return false;
    if (!('changedAt' in value) || value['changedAt'] === undefined)
        return false;
    if (!('event' in value) || value['event'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    return true;
}
export function ResponseChangeFromJSON(json) {
    return ResponseChangeFromJSONTyped(json, false);
}
export function ResponseChangeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fromValue': json['from_value'],
        'toValue': json['to_value'],
        'changedAt': (new Date(json['changed_at'])),
        'event': EventFromJSON(json['event']),
        'user': ResponseChangeUserFromJSON(json['user']),
    };
}
export function ResponseChangeToJSON(json) {
    return ResponseChangeToJSONTyped(json, false);
}
export function ResponseChangeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'from_value': value['fromValue'],
        'to_value': value['toValue'],
        'changed_at': ((value['changedAt']).toISOString()),
        'event': EventToJSON(value['event']),
        'user': ResponseChangeUserToJSON(value['user']),
    };
}
